module.exports = __webpack_public_path__ + "trust-marks-entrepreneur.a658d6.png";